import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { isRoundTrip as getIsRoundTrip } from '../../../../../Checkout/store/order/selectors';
import { FlightDetails, getSelectedSegment } from '@entities/seat-map';
import { SuggestionModal } from '@features/seat-map';
import { SeatsLegendModalButton } from '@features/seat-map/show-legend-modal';
import { Toolbar } from '../Toolbar';
import { PassengersList } from '../PassengersList';
import { SeatsLegend } from '../SeatsLegend';
import SeatMapProvider from './SeatMapProvider';
import { useTheme } from '../../../../../theme';
import { useIsMobile } from '../../../../../utils';
import { useOnMount, useRecommendedSeats } from '../../lib';
const SeatMap = ({ onNextStep, onPrevStep }) => {
    const { SeatMap: theme } = useTheme('Widgets').SeatMap;
    const isMobile = useIsMobile();
    const selectedSegment = useSelector(getSelectedSegment);
    const isRoundTrip = useSelector(getIsRoundTrip);
    const { activeRecommendedSeats } = useRecommendedSeats();
    useOnMount();
    return (React.createElement(SeatMapProvider, { onNextStep: onNextStep, onPrevStep: onPrevStep },
        React.createElement(Toolbar, null,
            React.createElement("div", { className: theme.wrapper },
                React.createElement("div", { className: theme.root },
                    activeRecommendedSeats && !isMobile && React.createElement("div", { className: theme.overlay }),
                    React.createElement("div", { className: cn(theme.aside, theme.aside_left) },
                        React.createElement(FlightDetails, { sunSide: selectedSegment.sunSide, segmentInfo: selectedSegment.segmentsInfo, isReturnFlight: selectedSegment.segmentsInfo.id === '1' && isRoundTrip }),
                        isMobile && React.createElement(SeatsLegendModalButton, null),
                        React.createElement(PassengersList, null)),
                    React.createElement("div", { className: theme.map }),
                    React.createElement("div", { className: cn(theme.aside, theme.aside_right) },
                        React.createElement(SeatsLegend, null)))),
            React.createElement(SuggestionModal, { onContinue: onNextStep }))));
};
export default SeatMap;
